"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.home = exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Types = require("../../types");
const Actions = require("../../actionTypes/project/home");
const _folderTreeReducer = require("../../modules/files/tree/reducers");
const _propertiesReducer = require("../../modules/files/crud/reducers");
const types_1 = require("./types");
const utils_1 = require("../../modules/usergroup/list/utils");
const folderTreeReducer = _folderTreeReducer.default('project/home', 'NO_INHERIT_SELECTION');
const propertiesReducer = _propertiesReducer.default('project/home');
const usergroupInviteReducer = types_1._usergroupInviteReducer.default('project/home');
//#region TYPES
const listInitialState = {
    categories: [],
    customerGroups: []
};
exports.initialState = {
    invite: Object.assign({}, usergroupInviteReducer.initialState),
    status: Types.STANDBY,
    groupStatus: 'STANDBY',
    shortcutStatus: 'STANDBY',
    list: Object.assign({}, listInitialState),
    shortcuts: [],
    folderTreeOverlayToggled: false,
    folderContent: folderTreeReducer.initialState,
    filesFolderProperties: propertiesReducer.initialState,
    isModifyingCover: false,
    cover: undefined
};
//#endregion
//#region LENSES
const listLens = monocle.Lens.fromProp('list');
const rootLens = monocle.Lens.fromProp('root');
const shortcutsLens = monocle.Lens.fromProp('shortcuts');
const shortcutStatusLens = monocle.Lens.fromProp('shortcutStatus');
const statusLens = monocle.Lens.fromProp('status');
const errorLens = monocle.Lens.fromProp('error');
const groupStatusLens = monocle.Lens.fromProp('groupStatus');
const folderTreeOverlay = monocle.Lens.fromProp('folderTreeOverlayToggled');
const isModifyingCoverLens = monocle.Lens.fromProp('isModifyingCover');
const coverLens = monocle.Lens.fromProp('cover');
const projectLens = monocle.Lens.fromProp('project');
const inviteLens = monocle.Lens.fromProp('invite');
let methods = {};
exports.methods = methods;
methods[Actions.CLEAR] = (state, action) => (Object.assign(Object.assign({}, exports.initialState), { status: state.status, root: state.root, project: state.status === 'FETCHED' ? state.project : undefined }));
methods[Actions.FETCH_PROJECT_BY_ID_SUCCESS] = (state, action) => fp.function.compose(projectLens.set(action.payload.project), rootLens.modify((cur) => {
    if (cur && cur.id !== action.payload.project.rootFolder) {
        return undefined;
    }
    return cur;
}), statusLens.modify((x) => (action.payload.updateStatus ? 'FETCHED' : x)))(state);
methods[Actions.FETCH_PROJECT_BY_ID_REQUEST] = (state, action) => statusLens.modify((x) => (action.payload.updateStatus ? 'FETCHING' : x))(state);
methods[Actions.FETCH_PROJECT_BY_ID_FAILURE] = (state, action) => {
    return fp.function.compose(statusLens.modify((x) => (action.updateStatus ? 'ERROR' : x)), errorLens.set(action.payload))(state);
};
methods[Actions.TOGGLE_SHOW_PARTIES_SUCCESS] = (state, action) => {
    if (state.status !== 'FETCHED') {
        return state;
    }
    const project = state.project;
    project.showPartiesTab = action.payload.showPartiesTab;
    return Object.assign(Object.assign({}, state), { project });
};
methods[Actions.TOGGLE_SHOW_PARTIES_FAILURE] = (state, action) => {
    return fp.function.compose(statusLens.modify((x) => (action.updateStatus ? 'ERROR' : x)), errorLens.set(action.payload))(state);
};
methods[Actions.FETCH_ROOT_SUCCESS] = (state, action) => rootLens.set(action.data.node)(state);
methods[Actions.FETCH_PROJECT_SHORTCUTS_REQUEST] = (state, action) => shortcutStatusLens.set('FETCHING')(state);
methods[Actions.FETCH_PROJECT_SHORTCUTS_SUCCCESS] = (state, action) => {
    action.data.files.sort((a, b) => (a.path || a.name).localeCompare(b.path || b.name));
    return fp.function.compose(shortcutsLens.set(action.data.files), shortcutStatusLens.set('FETCHED'))(state);
};
methods[Actions.FETCH_PROJECT_SHORTCUTS_FAILURE] = (state, action) => {
    return shortcutStatusLens.set('FAILED')(state);
};
methods[Actions.ADD_SHORTCUTS_REQUEST] = (state) => shortcutStatusLens.set('SAVING')(state);
methods[Actions.ADD_SHORTCUTS_SUCCESS] = (state) => shortcutStatusLens.set('SAVED')(state);
methods[Actions.ADD_SHORTCUTS_FAILED] = (state) => shortcutStatusLens.set('FAILED')(state);
methods[Actions.DELETE_SHORTCUT_SUCCESS] = (state, action) => {
    return shortcutsLens.modify((shortcuts) => shortcuts.filter((s) => s.id !== action.payload.folderId))(state);
};
// Group methods
methods[Actions.FETCH_PROJECT_GROUPS_REQUEST] = (state, action) => groupStatusLens.set('FETCHING')(state);
methods[Actions.FETCH_PROJECT_GROUPS_FAILED] = (state, action) => groupStatusLens.set('FAILED')(state);
methods[Actions.FETCH_PROJECT_GROUPS_SUCCESS] = (state, action) => {
    return fp.function.compose(groupStatusLens.set('FETCHED'), listLens.set({
        customerGroups: [],
        categories: (0, utils_1.handleGroups)(action.payload.list, 'user', 'asc')
    }))(state);
};
methods[Actions.TOGGLE_FOLDER_TREE_OVERLAY] = (state, action) => {
    return folderTreeOverlay.modify((x) => !x)(state);
};
methods[Actions.UPLOAD_PROJECT_COVER_REQUEST] = (state, action) => isModifyingCoverLens.set(true)(state);
methods[Actions.UPLOAD_PROJECT_COVER_SUCCESS] = (state, action) => fp.function.compose(coverLens.set(action.cover), isModifyingCoverLens.set(false))(state);
methods[Actions.UPLOAD_PROJECT_COVER_FAILURE] = (state, action) => isModifyingCoverLens.set(false)(state);
methods[Actions.REMOVE_PROJECT_COVER_REQUEST] = (state, action) => isModifyingCoverLens.set(true)(state);
methods[Actions.REMOVE_PROJECT_COVER_SUCCESS] = (state, action) => fp.function.compose(coverLens.set(''), isModifyingCoverLens.set(false))(state);
const folderContentLens = monocle.Lens.fromProp('folderContent');
const propertiesLens = monocle.Lens.fromProp('filesFolderProperties');
const folderContentMethods = Object.keys(folderTreeReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => folderContentLens.set(folderTreeReducer.reducer(state.folderContent, action))(state);
    return prev;
}, {});
const propertiesMethods = Object.keys(propertiesReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => propertiesLens.set(propertiesReducer.reducer(state.filesFolderProperties, action))(state);
    return prev;
}, {});
exports.methods = methods = Object.assign(methods, folderContentMethods, propertiesMethods);
const handleInvite = (action) => (state) => {
    const fn = usergroupInviteReducer.methods[action.type];
    if (fn) {
        return inviteLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleState = (action) => (state) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
function home(state, action) {
    return fp.function.compose(handleInvite(action), handleState(action))(state);
}
exports.home = home;
//# sourceMappingURL=home.js.map